import { render, staticRenderFns } from "./float-shiyong.vue?vue&type=template&id=40cb8443&"
import script from "./float-shiyong.vue?vue&type=script&lang=js&"
export * from "./float-shiyong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports